import { ArrowBack } from "@mui/icons-material";
import { Box, Button, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useViewMode } from "./useViewMode";
import { ViewModeType } from "./ViewModeProvider";

const SwitchMode = () => {
  const { mode, setMode, font, setFont } = useViewMode();
  const useHandleModeChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newMode: ViewModeType | null) => {
      if (newMode) {
        setMode(newMode);
      }
    },
    [setMode]
  );
  const useHandleFontChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newFont: number | null) => {
      if (newFont) {
        setFont(newFont);
      }
    },
    [setFont]
  );
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box>
        {location.pathname !== "/" && (
          <Button
            sx={{ ml: -3 }}
            variant="text"
            startIcon={<ArrowBack />}
            onClick={() => navigate("/")}
          >
            Wróć do generowania harmonogramu wywozu śmieci
          </Button>
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <ToggleButtonGroup
          sx={{ justifyContent: "flex-end", pb: 2 }}
          color="primary"
          value={font}
          exclusive
          onChange={useHandleFontChange}
          aria-label="Zmiana rozmiaru czcionki"
          size="small"
        >
          <ToggleButton
            sx={{ p: 2, fontWeight: "bold" }}
            value={14}
            aria-label="Domyślny rozmiar (14)"
          >
            A
          </ToggleButton>
          <ToggleButton
            sx={{ p: 2, fontWeight: "bold" }}
            value={16}
            aria-label="Powiększony rozmiar (16)"
          >
            AA
          </ToggleButton>
          <ToggleButton
            sx={{ p: 2, fontWeight: "bold" }}
            value={18}
            aria-label="Duży rozmiar (18)"
          >
            AAA
          </ToggleButton>
          <ToggleButton
            sx={{ p: 2, fontWeight: "bold" }}
            value={20}
            aria-label="Największy rozmiar (20)"
          >
            AAAA
          </ToggleButton>
        </ToggleButtonGroup>
        <ToggleButtonGroup
          sx={{ justifyContent: "flex-end", pb: 2 }}
          color="primary"
          value={mode}
          exclusive
          onChange={useHandleModeChange}
          aria-label="Zmiana kontrastu"
          size="small"
        >
          <ToggleButton sx={{ p: 2, fontWeight: "bold" }} value="contrast">
            Kontrast
          </ToggleButton>
          <ToggleButton sx={{ p: 2, fontWeight: "bold" }} value="light">
            Jasny
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default SwitchMode;
